export default "<ion-app>\r\n  <ion-router-outlet>\r\n    <app-loader *ngIf=\"loading\"></app-loader>\r\n  </ion-router-outlet>\r\n</ion-app>\r\n"